/**
 * Three lifetime stat cards above the chart. Ported from
 * aieweb/components/admin/signups-summary.tsx onto the dashboard's shadcn
 * SummaryCard primitive.
 *
 * Cards ALWAYS show lifetime numbers regardless of the active table/chart date
 * range, search, or segment tab. Labels include "(all time)" so the summary is
 * not conflated with the filtered table below.
 */
import { SummaryCard } from "@/components/ui/summary-card";
import {
  summarizeSignups,
  type SignupDateRow,
} from "./signupsAggregation";

export interface SignupsSummaryProps {
  /** Real + demo signup rows (lifetime, from the projection). */
  orgs: SignupDateRow[];
  /** Orphan signup rows (lifetime, from the projection). */
  orphans: SignupDateRow[];
  /** Anchored to the projection's generatedAt (with staleness fallback). */
  now: Date;
  /** Resolved IANA timezone string. */
  timezone: string;
}

export function SignupsSummary({
  orgs,
  orphans,
  now,
  timezone,
}: SignupsSummaryProps) {
  const stats = summarizeSignups(orgs, orphans, now, timezone);
  const tz = `Local timezone: ${timezone}`;
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <SummaryCard
        label="Total signups (all time)"
        value={stats.total.toLocaleString()}
        tooltipText={tz}
      />
      <SummaryCard
        label="Signups this week"
        value={stats.thisWeek.toLocaleString()}
        comparisonLabel={`${stats.priorWeek.toLocaleString()} prior`}
        tooltipText={`${tz} — ISO week (Monday-start)`}
      />
      <SummaryCard
        label="Signups today"
        value={stats.today.toLocaleString()}
        comparisonLabel={`${stats.priorDay.toLocaleString()} prior`}
        tooltipText={tz}
      />
    </div>
  );
}
